import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import Logo from "./Logo";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL } from "../config";
import { scrollToId } from "../lib/scroll";

const EASE = [0.16, 1, 0.3, 1];

const LINKS = [
  { label: "Consultoria", id: "consultoria" },
  { label: "Método", id: "metodo" },
  { label: "Planos", id: "planos" },
  { label: "FAQ", id: "faq" },
  { label: "Contato", id: "contato" },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/10">
      <div className="container-x pt-16 md:pt-24">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div>
            <Logo />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/50">
              Consultoria premium de treino e dieta pelo app da Prime
              Coaching. Protocolo individual, acompanhamento diário, resultado
              real.
            </p>
          </div>
          <nav className="flex flex-col gap-3">
            {LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => scrollToId(l.id)}
                className="text-left font-mono text-[11px] uppercase tracking-[0.25em] text-white/50 transition-colors hover:text-white"
              >
                {l.label}
              </button>
            ))}
          </nav>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="flex h-12 items-center gap-3 self-start border border-white/15 px-5 font-mono text-[11px] uppercase tracking-[0.2em] text-white/60 transition-colors duration-300 hover:bg-white hover:text-black"
          >
            <Instagram className="h-5 w-5" />
            {INSTAGRAM_HANDLE}
          </a>
        </div>

        <motion.p
          initial={{ y: 60, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 1, ease: EASE }}
          aria-hidden="true"
          className="text-stroke-thick mt-16 select-none text-center font-display text-[22vw] font-black uppercase leading-[0.78] whitespace-nowrap md:text-[17vw]"
        >
          LF TEAM
        </motion.p>

        <div className="flex flex-col items-center justify-between gap-2 border-t border-white/10 py-6 font-mono text-[10px] uppercase tracking-[0.2em] text-white/35 md:flex-row">
          <span>© 2026 LF TEAM — Consultoria Premium</span>
          <span>Feito para transformar</span>
        </div>
      </div>
    </footer>
  );
}
